module.exports = __webpack_public_path__ + "img/1.d0037756.jpg";